import { render, staticRenderFns } from "./No12.vue?vue&type=template&id=fc4778b0&scoped=true"
import script from "./No12.vue?vue&type=script&lang=js"
export * from "./No12.vue?vue&type=script&lang=js"
import style0 from "./No12.vue?vue&type=style&index=0&id=fc4778b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4778b0",
  null
  
)

export default component.exports